import { createSlice } from '@reduxjs/toolkit';
import { CarriersListStateType } from 'src/types/carriersList';

const initialState: CarriersListStateType = {
    data: null,
    loading: false,
    error: false,
};

export const carriersListSlice = createSlice({
    name: 'carriersList',
    initialState,
    reducers: {
        getCarriersListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getCarriersListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getCarriersListFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getCarriersListFetch,
    getCarriersListFetchSuccess,
    getCarriersListFetchFailure,
} = carriersListSlice.actions;

export default carriersListSlice.reducer;

